export interface Vertex {
  vertexPosition: string
  vertexNormal: string
}

export class KVPolygon {
  id: string
  label: string
  notes: string
  status: string
  interiorVisible: boolean
  visible: boolean
  vertices: Vertex[]

  constructor(id: string) {
    this.id = id
    this.label = ''
    this.notes = ''
    this.status = 'Not Started'
    this.interiorVisible = true
    this.visible = true
    this.vertices = []
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): KVPolygon {
    const polygon = new KVPolygon(json.polygonId)
    if (json.polygonLabel) polygon.label = json.polygonLabel
    if (json.polygonNotes) polygon.notes = json.polygonNotes
    if (json.polygonStatus) polygon.status = json.polygonStatus
    if (json.polygonInteriorVisible !== undefined)
      polygon.interiorVisible = json.polygonInteriorVisible
    if (json.polygonVisible !== undefined) polygon.visible = json.polygonVisible
    if (json.polygonVertices) polygon.vertices = json.polygonVertices
    return polygon
  }

  static toJSON(polygon: KVPolygon): any {
    return {
      polygonId: polygon.id,
      polygonLabel: polygon.label,
      polygonNotes: polygon.notes,
      polygonStatus: polygon.status,
      polygonInteriorVisible: polygon.interiorVisible,
      polygonVisible: polygon.visible,
      polygonVertices: polygon.vertices,
    }
  }
}
